export default __webpack_public_path__ + "static/media/E-WEB-Goal-13.a5a81d4d.png";